import { UrlInternal } from "common/constants/endpoints";

export interface BreadcrumbItem {
  label: string;
  isCurrent?: boolean;
}

export function shouldHidePageTitle(pathname: string): boolean {
  if (pathname.startsWith("/insight")) {
    return true;
  }

  if (pathname === UrlInternal.GROUP_SALE_LIST) {
    return true;
  }

  if (pathname.startsWith(UrlInternal.PURCHASE_SUMMARY)) {
    return true;
  }

  if (pathname.includes(UrlInternal.GROUP_SALE_ON_ORDER_CONFIRM)) {
    return true;
  }

  if (
    pathname.startsWith(`${UrlInternal.GROUP_SALE_LIST}/`) &&
    pathname.length > UrlInternal.GROUP_SALE_LIST.length + 1
  ) {
    return true;
  }

  if (pathname.includes(UrlInternal.ROUTES_ANNOUCEMENT_DETAIL)) {
    return true;
  }

  if (
    pathname.includes(UrlInternal.ROUTES_PUBLIC_NOTICE_DETAIL) &&
    pathname !== UrlInternal.PUBLIC_NOTICE
  ) {
    return true;
  }

  if (pathname.includes(UrlInternal.ROUTES_GROUP_SALE_GUIDE_DETAIL)) {
    return true;
  }

  if (/^\/mypage\/subscriptions\/order\/[^/]+$/.test(pathname)) {
    return true;
  }

  return false;
}

export function resolveBreadcrumbItems(
  pathname: string,
  translate: (key: string) => string
): BreadcrumbItem[] {
  if (
    pathname.startsWith(UrlInternal.PATHNAME_GROUP_SALE) ||
    pathname.startsWith(UrlInternal.PURCHASE_SUMMARY)
  ) {
    const section = "증권청약";

    if (pathname.includes(UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE)) {
      return [
        { label: section },
        { label: translate("GROUP_SALE_TITLE_CALENDAR"), isCurrent: true },
      ];
    }

    if (pathname.startsWith(UrlInternal.PURCHASE_SUMMARY)) {
      return [{ label: section }, { label: "매각현황", isCurrent: true }];
    }

    return [{ label: section }, { label: "공동구매", isCurrent: true }];
  }

  if (pathname.startsWith(UrlInternal.PATHNAME_CUSTOM_SERVICE)) {
    const section = "고객센터";

    if (pathname.includes(UrlInternal.PUBLIC_NOTICE)) {
      return [{ label: section }, { label: "공시", isCurrent: true }];
    }

    if (pathname.includes("/annoucement")) {
      return [
        { label: section },
        { label: translate("CUSTOMER_SERVICE_NOTICE"), isCurrent: true },
      ];
    }

    if (
      pathname.includes("/sale-guide") ||
      pathname.includes(UrlInternal.REGISTER_APPOINTMENT)
    ) {
      return [
        { label: section },
        { label: translate("CUSTOMER_SERVICE_USER_GUIDE"), isCurrent: true },
      ];
    }

    if (pathname.includes(UrlInternal.QUESTION)) {
      return [
        { label: section },
        { label: translate("CUSTOMER_SERVICE_FAQ"), isCurrent: true },
      ];
    }

    return [
      { label: section },
      { label: translate("CUSTOMER_SERVICE_FAQ"), isCurrent: true },
    ];
  }

  if (pathname.startsWith("/insight")) {
    const section = "마켓인사이트";

    if (pathname.includes("/news-letter")) {
      return [
        { label: section },
        { label: translate("CUSTOMER_SERVICE_NEWSLETTER"), isCurrent: true },
      ];
    }

    if (pathname.includes("/temp")) {
      return [{ label: section }, { label: "Research", isCurrent: true }];
    }

    if (pathname.includes("/art-insight")) {
      return [{ label: section }, { label: "아트인사이드", isCurrent: true }];
    }

    return [{ label: section }, { label: "아트인사이드", isCurrent: true }];
  }

  if (pathname.startsWith(UrlInternal.PATHNAME_MYPAGE)) {
    const section = "마이페이지";

    if (pathname.includes("/subscriptions")) {
      return [{ label: section }, { label: "증권청약 내역", isCurrent: true }];
    }

    if (pathname.includes("/1:1-inquiry")) {
      return [{ label: section }, { label: "1:1 문의사항", isCurrent: true }];
    }

    if (pathname.includes("/my-account")) {
      return [{ label: section }, { label: "회원 정보 수정", isCurrent: true }];
    }

    return [{ label: section }, { label: "회원 정보 수정", isCurrent: true }];
  }

  return [];
}

export function resolvePageTitle(
  pathname: string,
  translate: (key: string) => string
): string | null {
  if (shouldHidePageTitle(pathname)) {
    return null;
  }

  const items = resolveBreadcrumbItems(pathname, translate);
  const current = items.find((item) => item.isCurrent);
  return current?.label ?? null;
}
